module.exports = __webpack_public_path__ + "img/hr.a9283a96.svg";